import api from "./axiosConfig";

// Amounts are in øre (minor units) — render with formatCurrency, which divides by 100.
export interface CashbackTriple {
  totalCashback: number;
  userCashback: number;
  revenue: number;
  transactionCount: number;
}

export interface NamedTriple {
  key: string;
  name: string;
  totals: CashbackTriple;
}

export interface RevenueSharingMonth {
  month: string; // "yyyy-MM"
  cardlinking: CashbackTriple;
  affiliateNetworks: NamedTriple[];
  apiPartners: NamedTriple[];
  reportingPartners: NamedTriple[];
  webshop: CashbackTriple;
  total: CashbackTriple;
}

export interface RevenueSharingReportResponse {
  fromMonth: string;
  toMonth: string;
  months: RevenueSharingMonth[];
}

export const getRevenueSharingReport = async (
  fromMonth: string,
  toMonth: string
): Promise<RevenueSharingReportResponse> => {
  try {
    const response = await api.post(
      "/business-account/get-revenue-sharing-report",
      { fromMonth, toMonth }
    );
    return response.data;
  } catch (error) {
    console.error("Getting revenue sharing report error:", error);
    throw error;
  }
};
